import React from 'react';
import SuccessDotIcon from '@assets/icons/dots/accepted.svg';
import FailureDotIcon from '@assets/icons/dots/rejected.svg';
import WarningDotIcon from '@assets/icons/dots/warning.svg';
import { capitalize, toLower } from 'lodash';

import { STATUS_TYPE, TABLE_STATUS } from '../constants.ts';
import type { Statuses, StatusType } from '../types.ts';
import { TableStatusWrapper, Title } from './styled.tsx';

interface Props {
    type: StatusType;
    label: string;
}

const getFormattedLabel = (label: Statuses) => {
    if (label === TABLE_STATUS.IN_PROGRESS) return capitalize('in progress');

    return capitalize(toLower(label));
};

const Status: React.FC<Props> = ({ type, label }) => (
    <TableStatusWrapper type={type}>
        {type === STATUS_TYPE.SUCCESS ? (
            <SuccessDotIcon />
        ) : type === STATUS_TYPE.FAILURE ? (
            <FailureDotIcon />
        ) : (
            <WarningDotIcon />
        )}
        <Title type={type}>{getFormattedLabel(label as Statuses)}</Title>
    </TableStatusWrapper>
);

export default Status;
